export default {
feedback: {
  title: "Comentarios",
  placeholder: "Deja un mensaje ({ contentLen }/1000 caracteres)",
  error: "Este es un mensaje de error",
  uploadLimit: "Límite de carga de imágenes y videos",
  send: "Enviar",
  tipTitle: "Ayúdanos a mejorar tu experiencia",
  desc1: "Puedes enviarnos cualquier pregunta, y si es aceptada, recibirás un paquete sorpresa.",
  desc2: "Si no te es conveniente enviarlas por la web, también puedes hacerlo por correo electrónico."
}
};
